// extracted by mini-css-extract-plugin
module.exports = {"feature":"feature--ChDXa6","icon":"icon--38qn7Q"};